export const createTimeFormatter = (langCode: string): Intl.DateTimeFormat => {
    return new Intl.DateTimeFormat(langCode, {
        hour: "numeric",
        minute: "2-digit"
    });
};
